import { FunctionalComponent, h } from 'preact';
import { styled } from 'linaria/react';

const LogoContainer = styled.div`
	width: 64px;
	height: 64px;
	background: white;
	border-radius: 50%;
	border: 2px solid white;
	overflow: hidden;
	box-shadow: 0 2px 8px rgba(0,0,0,0.15);
	position: absolute;
	bottom: 100%;
	left: 50%;
	transform: translateX(-50%) translateY(50%);
	z-index: 1;
`;

const Image = styled.img`
	width: 100%;
	height: 100%;
`;

export const Logo: FunctionalComponent<{ src: string } & any> = ({ src, ...props }) => {
	return (
		<LogoContainer {...props}>
			<Image src={src}/>
		</LogoContainer>
	);
};
